exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fab-button {\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  background: #ff8000;\n  color: white;\n  cursor: pointer; }\n  .fab-button img {\n    width: 35px; }\n  .chat-bot {\n  -webkit-transition: all 0.3s ease-out;\n  transition: all 0.3s ease-out;\n  position: fixed;\n  bottom: 10px;\n  right: -420px;\n  width: 400px;\n  height: 450px;\n  z-index: 10;\n  -webkit-box-shadow: rgba(0, 0, 0, 0.32) 0 1px 4px;\n          box-shadow: rgba(0, 0, 0, 0.32) 0 1px 4px;\n  background: white; }\n  .chat-bot.opened {\n    right: 10px; }\n  .chat-bot .close-button {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    cursor: pointer;\n    color: white; }\n  .chat-bot iframe {\n    width: 100%;\n    height: 100%;\n    border: 0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// d:/workspace/wynk_web_shoppings_3_prod/src/app/core/shell/shell.component.scss
// module id = ../../../../../src/app/core/shell/shell.component.scss
// module chunks = main